import {
  FETCH_REQUESTTYPE_ACTION,
  FETCH_REQUESTTYPE_SUCCESS_ACTION,
  FETCH_REQUESTTYPE_FAIL_ACTION,
  FETCH_PARTNER_ACTION,
  FETCH_PARTNER_SUCCESS_ACTION,
  FETCH_PARTNER_FAIL_ACTION,
  FETCH_SHIPPERINDIVIDUAL_SUCCESS_ACTION
} from "./action";

const initialState = {
  prcssng: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_REQUESTTYPE_ACTION:
      return {
        ...state,
        processing: true,
      };

    case FETCH_REQUESTTYPE_SUCCESS_ACTION:
     
      return {
        ...state,
        processing: false,
        error: false,
        errorCode: null,
        errorMessage: null,
        requesttypeList: action.payload.rows,
      };

    case FETCH_REQUESTTYPE_FAIL_ACTION:
      return {
        ...state,
        processing: false,
      };

    case FETCH_PARTNER_ACTION:
      return {
        ...state,
        processing: true,
      };

    case FETCH_PARTNER_SUCCESS_ACTION:
    
      return {
        ...state,
        processing: false,
        error: false,
        errorCode: null,
        errorMessage: null,
        partnerList: action.payload.rows,
        partnerCount: action.payload.count,
      };

    case FETCH_PARTNER_FAIL_ACTION:
      return {
        ...state,
        processing: false,
      };


    case FETCH_SHIPPERINDIVIDUAL_SUCCESS_ACTION:
     
      return {
        ...state,
    
        individualList: action.payload.rows,
        individualCount: action.payload.count,
      };

    default:
      return {
        ...state,
      };
  }
}
